import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { ToastContainer } from 'react-toastify';
// Formatting update to force rebuild
import { AuthProvider } from './contexts/AuthContext';
import { SubscriptionProvider } from './contexts/SubscriptionContext';
import './i18n'; // Import i18n configuration
import 'react-toastify/dist/ReactToastify.css';
import './css/font-awesome.min.css';

import './css/flaticon.css';
import './sass/style.scss';
import './components/hero/style.css';
import './components/about/about-custom.css';
import './components/about/about-custom-rtl.css'; // RTL styles for About section
import './components/FunFact/style.css';
import './components/Projects/style.css';
import './components/CustomBanner/style.css';
import './components/LevelTest/style.css';
import './components/LevelTest/style-rtl.css'; // RTL styles for LevelTest section
import './components/BlogSection/style.css';
import './components/BlogSection/style-rtl.css'; // RTL styles for BlogSection
import './components/ContactHome/compact.css';
import './components/ContactHome/compact-rtl.css'; // RTL styles for ContactHome
import './components/MobileMenu/style.css';
import './components/scrollbar/style.css';
import './components/PerformanceDashboard/style.css';
import './components/Features/style.css';
import './components/Services/style.css';
import './components/UIConfigDashboard/style.css';
import './pages/LoginPage/style.css';
import './pages/SignUpPage/style.css';
import './pages/ForgotPassword/style.css';
import './css/rtl.css'; // Global RTL overrides - imported last to ensure precedence
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <BrowserRouter>
        <AuthProvider>
          <SubscriptionProvider>
            <div className="App" id="scrool">
              <App />
              <ToastContainer />
            </div>
          </SubscriptionProvider>
        </AuthProvider>
      </BrowserRouter>
    </HelmetProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();